import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Darbostogos', href: '/darbostogos', isRoute: true },
    { name: 'Šventės', href: '/sventes', isRoute: true },
    { name: 'Stovyklos', href: '/stovyklos', isRoute: true },
    { name: 'Pirties namukas', href: '/pirties-namukas', isRoute: true },
    { name: 'Galerija', href: '/galerija', isRoute: true },
    { name: 'Kontaktai', href: '/kontaktai', isRoute: true },
  ];

  return (
    <header className="sticky top-0 z-40" style={{ backgroundColor: '#111315' }}>
      <div className="flex items-stretch justify-between">
        {/* Logo Section */}
        <Link to="/" className="flex items-center justify-center px-6 py-3">
          <img 
            src="/logo.png" 
            alt="Sporto Krantas" 
            className="h-16 w-auto object-contain"
          />
        </Link>

        {/* Main Navigation Area - Desktop */}
        <div className="hidden lg:flex flex-1 items-center justify-between px-8">
          {/* Desktop Navigation */}
          <nav className="flex items-center space-x-10">
            {navLinks.map((link) => (
              link.isRoute ? (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-white hover:text-[#D0AB64] font-medium text-sm tracking-wide transition-colors flex items-center"
                >
                  {link.name}
                </Link>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-white hover:text-[#D0AB64] font-medium text-sm tracking-wide transition-colors flex items-center"
                >
                  {link.name}
                  {link.name === 'Kontaktai' && (
                    <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </a>
              )
            ))}
          </nav>

          {/* Action Buttons */}
          <div className="flex items-center space-x-3">
            <a
              href="tel:+37063400056"
              className="inline-flex items-center px-5 py-2.5 text-[#D0AB64] font-medium text-sm border border-[#D0AB64] hover:bg-[#D0AB64] hover:text-[#111315] transition-colors"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Skambinti
            </a>
            <Link
              to="/rezervacija"
              className="inline-flex items-center px-5 py-2.5 text-[#111315] font-medium text-sm border border-[#D0AB64] hover:opacity-90 transition-colors"
              style={{ backgroundColor: '#D0AB64' }}
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Rezervacija
            </Link>
          </div>
        </div>

        {/* Mobile menu button - Far right */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="lg:hidden p-2 mr-4 self-center text-white hover:bg-gray-800 rounded-lg"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <nav className="lg:hidden py-4 px-6 border-t border-gray-800 bg-[#111315]">
          <div className="flex flex-col space-y-3">
            {navLinks.map((link) => (
              link.isRoute ? (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-white hover:text-[#D0AB64] font-medium py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-white hover:text-[#D0AB64] font-medium py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </a>
              )
            ))}
            <a
              href="tel:+37063400056"
              className="inline-flex items-center justify-center px-5 py-2.5 text-[#D0AB64] font-medium border border-[#D0AB64] mt-4"
              onClick={() => setIsMenuOpen(false)}
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Skambinti
            </a>
            <Link
              to="/rezervacija"
              className="inline-flex items-center justify-center px-5 py-2.5 text-[#111315] font-medium mt-2"
              style={{ backgroundColor: '#D0AB64' }}
              onClick={() => setIsMenuOpen(false)}
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Rezervacija
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
